import React from 'react';
import { Spinner } from 'react-bootstrap';

interface LoaderProps {
	variant?: string;
	style?: React.CSSProperties;
}

const CommonLoader: React.FC<LoaderProps> = ({ variant = 'dark', style = {} }) => (
	<div
		style={{
			position: 'fixed',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			backgroundColor: 'rgba(0, 0, 0, 0.5)',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			zIndex: 9999,
		}}
	>
		<Spinner animation="border" variant={variant} style={style} />
	</div>
);

export default CommonLoader;
